/**
 * Class description
 *
 * Created: 2017-10-09
 * @author jonas
 */
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TeslaReelController} from "./TeslaReelController";

export class TeslaReels {


    public static moveSymbolToBottomLayer(reelId:number, symbol:StateReelSymbol):void {
        const controller:TeslaReelController = <TeslaReelController>Reels.getReel(reelId);
        if(controller) {
            controller.moveSymbolToBottomLayer(symbol);
        }
    }

    public static moveSymbolToTopLayer(reelId:number, symbol:StateReelSymbol):void {
        const controller:TeslaReelController = <TeslaReelController>Reels.getReel(reelId);
        if(controller) {
            controller.moveSymbolToTopLayer(symbol);
        }
    }

}